import CategoryService from "src/services/CategoryService";
import ModuleCreator from "src/store/ModuleCreator";

export const types = {};
export const params = {
  name: ""
};

/**
 @namespace
 @property  {object} module,
 @property  {object} module.state,
 @property  {object} modules.category,
 @property  {array}  modules.categories
 **/

const module = {
  state: {},
  mutations: {},
  getters: {},
  actions: {},
  types: types,
};
export default ModuleCreator({ name: "category", plural: "categories" }, CategoryService, module, types, params);
